export interface ApiGetHiroBasicResponse {
    copilot_flag: boolean;
    /** 对象 key 是 agentCode */
    agent_flag: Record<string, boolean>;
    /** 智能体配置，key 为智能体 code，value 为智能体配置 */
    agent_config?: Record<string, {
        user_cases: Array<{
            task_id: string;
            label_key: string;
        }>;
        selected_limit: number;
    }>;
}

export const GetHiroBasic = Symbol.for('GetHiroBasic');

export interface GetHiroBasic {
    getHiroBasic(): Promise<ApiGetHiroBasicResponse>;
}
